module.exports = "/images/vendor/flag-icon-css/flags/1x1/cv.svg?20a8cfffe0e96905132967daae5e2578";